/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".notifier__container *{box-sizing:border-box}.notifier__container-list{margin-top:0;margin-bottom:0;padding-left:0;list-style-type:none}.notifier__notification{display:block;position:fixed;visibility:hidden;z-index:10000;will-change:transform;-webkit-backface-visibility:hidden;backface-visibility:hidden}"];
export { styles as styles };
